import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth';

export const adminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const roles = authService.currentUser()?.roles as string[] | undefined;
  const isAdmin = roles?.includes('super_admin') || roles?.includes('admin');

  return isAdmin ? true : router.parseUrl('/content-manager');
};
